import React, { useMemo } from 'react';
import * as yup from 'yup';
import { Box } from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoginForm from './forms/LoginForm';
import { passwordSchema } from '../../utils/yupSchema';
import { useAppContext } from '../../context/appContext';
import { SIGNUP_METHOD } from '../../../../constants/userSetting';
import { validateMailAndMobile } from '../../../../utils/validators';

const errorMessageI18nKey = {
  [SIGNUP_METHOD.EMAIL]: {
    required: 'Validation - email - required',
    invalid: 'Validation - email - invalid',
  },
  [SIGNUP_METHOD.MOBILE]: {
    required: 'Validation - mobile phone - required',
    invalid: 'Validation - mobile phone - invalid',
  },
  [SIGNUP_METHOD.EMAIL_AND_MOBILE]: {
    required: 'Validation - email and mobile - required',
    invalid: 'Validation - email and mobile - invalid',
  },
};

const LoginSection = () => {
  const { userSetting } = useAppContext();

  const emailAndMobileSchema = useMemo(() => {
    return yup
      .string()
      .required(errorMessageI18nKey[userSetting.signup_method].required)
      .test(
        'custom',
        errorMessageI18nKey[userSetting.signup_method].invalid,
        validateMailAndMobile,
      );
  }, [userSetting?.signup_method]);

  const schema = yup.object().shape({
    emailAndMobile: emailAndMobileSchema.nullable(),
    password: passwordSchema,
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });

  return (
    <Box>
      <FormProvider {...methods}>
        <LoginForm />
      </FormProvider>
    </Box>
  );
};

export default LoginSection;
